<template>
  <div class="home">
    <b-container>
      <b-row class="d-block">
        <b-carousel indicators>
          <b-carousel-slide :key="banner.id" v-for="banner in banners">
            <p v-if="user.is_staff">
              <b-button
                :key="level"
                class="mr-1"
                :disabled="banner.level === level"
                size="sm"
                @click="setBannerLevel(banner, level)"
                v-for="level in [5, 4, 3, 2, 1, null]"
                >{{ level || "X" }}</b-button
              >
            </p>
            <a slot="img" :href="banner.url">
              <img
                class="w-100 h-100"
                style="object-fit: cover;"
                :src="banner.image"
              />
            </a>
          </b-carousel-slide>
        </b-carousel>
      </b-row>
    </b-container>

    <div class="navigator-container d-none d-lg-block">
      <b-container>
        <b-row class="navigator">
          <b-col cols="12" md="4" class="mb-2">
            <a
              href="https://axoo.notion.site/FOR-ARTISTS-12847ee5dd958155b08af81ddaa15014"
              target="_blank"
            >
              <b-card title="ARTIST">
                <p class="card-text">
                  픽스필즈 멤버십으로 다양한 혜택을 누리세요.<br />
                  Grow Together, with pixpills™.
                </p>
              </b-card>
            </a>
          </b-col>
          <b-col cols="12" md="4" class="mb-2">
            <a
              href="https://axoo.notion.site/FOR-BRAND-AGENCY-12847ee5dd9581058d65c9a01046ddfe"
              target="_blank"
            >
              <b-card title="BRANDS & AGENCIES">
                <p class="card-text">
                  효과적인 아트 캠페인 솔루션을 만나보세요.<br />
                  Make Creative Solution!
                </p>
              </b-card>
            </a>
          </b-col>
          <b-col cols="12" md="4" class="mb-2">
            <a
              href="https://axoo.notion.site/pixpills-x-12f47ee5dd9580099036c403ef8ed499"
              target="_blank"
            >
              <b-card title="PROJECT">
                <p class="card-text">
                  픽스필즈에서는 다채로운 프로젝트를 기획 및 운영합니다.<br />
                  Creative projects run by pixpills™.
                </p>
              </b-card>
            </a>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container>
      <p class="best-projects home-sub-nav mb-0">
        Best Projects
      </p>
    </b-container>

    <artworks v-model="bestProjects" @update="sortArtworks" />
    <slot />

    <div class="show-gallery d-flex justify-content-center">
      <b-button :to="'/gallery/all/'" variant="link"> </b-button>
    </div>

    <hr />

    <div class="clients">
      <b-container>
        <p class="home-sub-nav">
          Partners
        </p>
        <b-row>
          <swiper :options="swiperOptions">
            <swiper-slide :key="client.id" v-for="client in clients">
              <p
                v-if="user.is_staff"
                style="position: absolute; top: 0; left: 0; margin: auto 0;"
              >
                <b-button
                  :key="level"
                  class="mr-1"
                  :disabled="client.level === level"
                  size="sm"
                  @click="setClientLevel(client, level)"
                  v-for="level in [5, 4, 3, 2, 1, null]"
                  >{{ level || "X" }}</b-button
                >
              </p>
              <a :href="client.url" target="_blank">
                <div
                  class="d-none justify-content-center align-items-center"
                  style="position: absolute; top: 0; bottom: 0; left: 0; right: 0;"
                >
                  {{ client.benefit }}
                </div>
                <img :src="client.image" class="img-fluid" />
              </a>
            </swiper-slide>

            <div class="swiper-button-next" slot="button-next">
              <img src="../assets/right.png" class="img-fluid" />
            </div>
            <div class="swiper-button-prev" slot="button-prev">
              <img src="../assets/left.png" class="img-fluid" />
            </div>
          </swiper>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Artworks from "../components/Artworks.vue";
import CategoryBar from "../components/CategoryBar.vue";
import axios from "axios";

export default Vue.component("home", {
  components: {
    Artworks,
    CategoryBar
  },
  data() {
    return {
      user: window.user,
      banners: window.banners,
      clients: window.clients,
      bestProjects: window.bestProjects,
      swiperOptions: {
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  mounted() {
    this.sortBanners();
    this.sortClients();
    this.sortArtworks();
  },
  methods: {
    sortBanners() {
      this.banners.sort((a, b) => {
        return b.level - a.level || b.id - a.id;
      });
    },
    sortClients() {
      this.clients.sort((a, b) => {
        return b.level - a.level || b.id - a.id;
      });
    },
    sortArtworks() {
      this.bestProjects.results = this.bestProjects.results.filter(
        p => p.level
      );
      this.bestProjects.results.sort((a, b) => {
        return b.level - a.level || b.id - a.id;
      });
    },
    async setBannerLevel(banner, level) {
      if (banner.level === level) {
        level = null;
      }

      banner.level = level;

      await axios.put(`/api/v1/banners/${banner.id}/`, banner);
      this.sortBanners();
    },
    async setClientLevel(client, level) {
      if (client.level === level) {
        level = null;
      }

      client.level = level;

      await axios.put(`/api/v1/clients/${client.id}/`, client);
      this.sortClients();
    }
  }
});
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap-grid.scss";

.navigator-container {
  margin-top: 45px;
  background-color: #f7f7f7;

  .navigator {
    .card {
      height: 100%;
      background-color: #f7f7f7;
      border: none;

      .card-title {
        display: inline-block;
        font-size: 25px !important;
        border-radius: 10px;
        color: #000;
        font-family: Josefin Sans, sans-serif;
        font-weight: bold;
      }

      .card-text {
        color: black;
      }

      &:hover {
        background-color: #b10101;

        .card-title {
          color: white;
        }

        .card-text {
          color: white;
        }
      }
    }
  }
}

.best-projects {
  padding: 70px 0;
}

.artwork-container {
  overflow: hidden;

  @media (min-width: 548px) {
    max-height: 297 * 10px !important;
  }

  @media (min-width: 812px) {
    max-height: 297 * 7px !important;
  }

  @media (min-width: 1076px) {
    max-height: 297 * 5px !important;
  }

  @media (min-width: 1340px) {
    max-height: 297 * 4px !important;
  }

  @media (min-width: 1604px) {
    max-height: 297 * 3px !important;
  }
}

.show-gallery {
  @media (min-width: 548px) {
    margin-top: 80px;
  }

  margin-top: 108px;
  margin-bottom: 120px;

  a {
    height: 12px;
    width: 113px;
    background: url("../assets/load_more.png");
    background-size: cover;
    border-radius: 0;

    &:hover {
      filter: blur(1px);
    }
  }
}

.home-sub-nav {
  text-align: center;
  font-family: Josefin Sans, sans-serif;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
}

.clients {
  background-color: #f7f7f7;
  padding-top: 50px;
  margin: 70px 0;

  .home-sub-nav {
    margin: 0;
  }
}

.swiper-slide {
  height: 100px;
  width: 100px;

  @media (min-width: 548px) {
    height: 200px;
    width: 200px;
  }
}

.swiper-container {
  padding-top: 70px;
  padding-bottom: 70px;

  @include media-breakpoint-up(sm) {
    padding: 70px;
  }
}

.swiper-slide {
  margin-left: 10px;
  margin-right: 10px;

  a {
    display: block;
    overflow: hidden;
    border-radius: 50%;
    background-color: #b10101;
    font-size: 13px;

    div {
      pointer-events: none;
      color: white;
    }

    &:hover {
      img {
        visibility: hidden;
      }

      div {
        display: flex !important;
      }
    }
  }
}

.swiper-button-prev,
.swiper-button-next {
  display: none;
  width: 93px;
  height: 79px;
  margin-top: -40px;
  background-image: none;

  @include media-breakpoint-up(sm) {
    display: block;
  }
}

.swiper-button-prev {
  left: 0;
}

.swiper-button-next {
  right: 0;
}
</style>
